import React from 'react';

import type { UUID } from '@aline/common';
import { UploadFileVersionPicker } from 'src/components';
import { FileStackDomContainer, wordMimeTypes } from 'src/helpers';

import { useTaskReviewActions } from './use-task-review-actions';

interface TaskFileUploadProps {
  documentId: UUID;
  onClose: () => void;
  taskId: UUID;
}

/**
 * Upload a file as a new version of a workflow document on the task. Records no decision: the
 * uploader approves, requests changes or completes from the task's buttons, once for every file.
 */
export function TaskFileUpload({ documentId, onClose, taskId }: TaskFileUploadProps): JSX.Element {
  const { uploadResponse } = useTaskReviewActions(taskId);

  return (
    <UploadFileVersionPicker
      open
      domContainer={FileStackDomContainer.FileVersion}
      pickerOpts={{
        accept: [...wordMimeTypes],
        createFromUpload: async fileLocation => {
          await uploadResponse({ documentId, fileLocation });
          return null;
        },
        documentId,
        onClose,
      }}
    />
  );
}
